import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface FileNameProps {
  className?: string;
  fileName: string;
  maxLength?: number;
}

export function FileName({ className = '', fileName, maxLength = 30 }: FileNameProps) {
  const truncatedName =
    fileName.length > maxLength ? `${fileName.slice(0, maxLength)}...` : fileName;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={`text-foreground block max-w-full cursor-pointer truncate font-['Inter'] text-[13px] ${className}`}
        >
          {truncatedName}
        </span>
      </TooltipTrigger>
      <TooltipContent
        align="start"
        className="max-h-[110px] max-w-[180px] translate-x-2 overflow-y-auto px-2 py-1"
        side="top"
        sideOffset={6}
      >
        <p className="m-0 leading-[140%] break-words whitespace-normal">{fileName}</p>
      </TooltipContent>
    </Tooltip>
  );
}
